import { render, staticRenderFns } from "./ClientAccessList.vue?vue&type=template&id=50761e28"
import script from "./ClientAccessList.vue?vue&type=script&lang=js"
export * from "./ClientAccessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports